
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/help/return-shipment",
      function () {
        return require("private-next-pages/help/return-shipment.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/help/return-shipment"])
      });
    }
  